class HumanFeedbackError extends Error {
  constructor(public humanMessage: string, ...params: any[]) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params)

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, HumanFeedbackError)
    }

    this.name = 'CustomError'
  }
}

export default HumanFeedbackError
